module.exports = __webpack_public_path__ + "img/title.3b56e98e.png";